import classNames from 'classnames';
import { downcastRef } from '../../util/typing';
import Scroll from '../data/Scroll';
import Card from './Card';
import CardActions from './CardActions';
import CardContent from './CardContent';
import CardHeader from './CardHeader';
import CardTitle from './CardTitle';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
/**
 * Render a composed set of Card components in a panel-like interface.
 *
 * If the total height of the Panel exceeds any height constraints set on the
 * Panel's immediate parent element, content (`children`) will scroll. The
 * header and any buttons will not scroll.
 */
export default function Panel({
  children,
  elementRef,
  buttons,
  fullWidthHeader = false,
  icon: Icon,
  onClose,
  paddingSize = 'md',
  scrollable = false,
  title,
  ...htmlAttributes
}) {
  // These classes are set on the content container hierarchy in this component
  // to ensure that the overall height is constrained to height rules set on
  // parent elements. This allows for control over scrolling content,
  // specifically.
  const heightConstraintClasses = 'flex flex-col min-h-0 h-full';
  const panelContent = paddingSize === 'none' ? children : _jsx(CardContent, {
    classes: heightConstraintClasses,
    "data-testid": "panel-content-wrapper",
    size: paddingSize,
    children: children
  });
  return _jsxs(Card, {
    "data-composite-component": "Panel",
    ...htmlAttributes,
    classes: heightConstraintClasses,
    elementRef: downcastRef(elementRef),
    children: [_jsxs(CardHeader, {
      onClose: onClose,
      fullWidth: scrollable || fullWidthHeader,
      children: [Icon && _jsx(Icon, {
        className: "w-em h-em"
      }), _jsx(CardTitle, {
        children: title
      })]
    }), scrollable ? _jsx(Scroll, {
      classes: classNames({
        // When no buttons are provided (which means this is the last children),
        // inherit the bottom border radius from Card.
        'rounded-b-[inherit]': !buttons
      }),
      children: panelContent
    }) : _jsx(_Fragment, {
      children: panelContent
    }), buttons && _jsx(CardContent, {
      "data-testid": "panel-buttons",
      children: _jsx(CardActions, {
        children: buttons
      })
    })]
  });
}
//# sourceMappingURL=Panel.js.map